export enum Functionalities {
    Daily = 'daily',
    Financials = 'financials',
    GlobalReports = 'globalReports',
    HourRegistration = 'hourRegistration',
    Leave = 'leave',
    LeaveManagement = 'leaveManagement',
    PdfUnderlay = 'pdfUnderlay',
    Permissions = 'permissions',
    Seire = 'seire',
    SeireManagement = 'seireManagement',
    Subscriptions = 'subscriptions',
    Users = 'users',
    Weekly = 'weekly',
}
